import React from 'react';

const SECTIONS = [
  { title: 'Data Collection', content: 'We collect only the minimum data required to operate the MyHealth Journal provider portal, including your registration details, uploaded reports, and patient interaction logs.' },
  { title: 'How We Use Your Data', content: 'Your data is used to facilitate report uploads to patients, maintain audit logs for compliance, and improve our services. We never sell your data to third parties.' },
  { title: 'Data Security', content: 'All data is encrypted using AES-256 at rest and TLS 1.3 in transit. We follow HIPAA and ABDM compliance standards to ensure patient data protection.' },
  { title: 'Report Handling', content: 'Reports uploaded by you are stored securely and accessible only to the intended patient after their explicit consent. Rejected reports are permanently deleted.' },
  { title: 'Your Rights', content: 'You have the right to access, update, or delete your account data. For any requests contact our Data Protection Officer at dpo@myhealthjournal.in.' },
  { title: 'Contact Us', content: 'For privacy-related concerns, email us at privacy@myhealthjournal.in or write to: VH Mobile Metrics Pvt Ltd, Hyderabad, Telangana, India.' },
];

export default function MobileProviderPrivacyPolicy({ onBack }) {
  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <p className="font-black text-lg text-[#141a3d]">Privacy Policy</p>
      </div>

      <div className="px-4 mt-4 space-y-3">
        <p className="text-xs text-gray-400 font-semibold">Last updated: January 2025</p>
        {SECTIONS.map((s, i) => (
          <div key={i} className="bg-white rounded-2xl p-4 shadow-sm">
            <p className="font-extrabold text-sm text-[#141a3d] mb-2">{s.title}</p>
            <p className="text-sm text-gray-500 leading-relaxed">{s.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}